import React from "react";
import ImageCard from "../Basic/ImageCard";
import securityIllustrationSrc from "../../assets/illustrations/platform-security.svg";

const ResponsibleAI = () => {
  return (
    <div className="px-10 py-12 relative bg-green-light -mb-1">
      <div className="w-full lg:max-w-7xl mx-auto flex items-center justify-center">
        <ImageCard
          image={
            <img
              src={securityIllustrationSrc}
              alt="security"
              className="mx-auto max-w-[75vw] sm:max-w-md lg:max-w-2xl object-fill object-center"
              width="409"
              height="409"
            />
          }
          title={
            <p>
              Responsible AI.
              <br />
              Security at our core.
            </p>
          }
          desc="Quadrant is committed to using non-diagnostic artificial intelligence responsibly and ethically within healthcare. Our platform is built prioritizing security and privacy every step of the way."
          reverse
        />
      </div>
    </div>
  );
};

export default ResponsibleAI;
